import React, { useState, useEffect, useCallback } from 'react';
import Truncate from 'react-truncate';
import { Group } from '@visx/group';
import { useTooltip, TooltipWithBounds } from '@visx/tooltip';
import { AxisLeft, AxisBottom } from '@visx/axis';
import { scaleBand, scaleLinear } from '@visx/scale';
import { LinePath, Bar } from '@visx/shape';
import { localPoint } from '@visx/event';
import PropTypes from 'prop-types';

import {
  getParams,
  getMonth,
  thousandFormat,
  thousandFormat2,
  getMonths2,
  getMonths,
} from '../../../../Utils/Functions';
import {
  enMonths,
  activeLabelColor,
  positiveActiveColor,
  formatedStyle,
} from '../../../../Assets/js/constant';

let tooltipTimeout;

const BottomChart = ({
  summaryData,
  defaultMonth,
  defaultStartMonth,
  updateFilter,
  selectedTopItems,
  selectedLeftItems,
  selectedRightLabels,
  selectedRightItems,
  choice,
}) => {
  const { tooltipOpen, tooltipTop, tooltipLeft, tooltipData, showTooltip, hideTooltip } = useTooltip();
  
  const [resize, setResize] = useState(false);
  const [selectedBars, setSelectedBars] = useState([]);
  const [savedLeftItems, setSavedLeftItems] = useState([]);
  const [linedata, setLinedata] = useState([]);
  const [data, setData] = useState([]);
  const [selectedLines, setSelectedLines] = useState([]);

  const _onResize = useCallback(() => {
    setResize(prev => !prev);
    setSelectedLines([]);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', _onResize);
    return () => window.removeEventListener('resize', _onResize);
  }, [_onResize]);

  const _prepareData = useCallback(() => {
    let selectedMonths = selectedRightItems;
    let dictData = {},
      _dictData = {};
    let newData = [];
    let newLinedata = [];

    if (summaryData.length === 0) return;
    summaryData.sort((a, b) => a.Sort - b.Sort);
    let _linedata = {};
    let bFilter = false;
    summaryData.forEach((item) => {
      let month = getMonth(item.Date);
      let key = '';
      let Outcome = 'Achieved';
      if (item.DesiredOutcome === 'Less') {
        if (parseFloat(item.Result) <= parseFloat(item.Target))
          Outcome = 'Achieved';
        else if (
          parseFloat(item.Result) > parseFloat(item.Target) &&
          parseFloat(item.Result) <=
            parseFloat(item.Target) + parseFloat(item.Tolerance)
        )
          Outcome = 'Neutral';
        else if (
          parseFloat(item.Result) >=
          parseFloat(item.Target) + parseFloat(item.Tolerance)
        )
          Outcome = 'Not Achieved';
      } else if (item.DesiredOutcome === 'Greater') {
        if (parseFloat(item.Result) >= parseFloat(item.Target))
          Outcome = 'Achieved';
        else if (
          parseFloat(item.Result) >=
            parseFloat(item.Target) - parseFloat(item.Tolerance) &&
          parseFloat(item.Result) < parseFloat(item.Target)
        )
          Outcome = 'Neutral';
        else if (
          parseFloat(item.Result) <=
          parseFloat(item.Target) - parseFloat(item.Tolerance)
        )
          Outcome = 'Not Achieved';
      }
      if (choice === 'Group') {
        key = item.Group;
      } else if (choice === 'Result') {
        if (Outcome === 'Neutral') key = 'Neutral';
        else if (Outcome === 'Achieved') key = 'Good';
        else key = 'Bad';
      } else if (choice === 'Importance') {
        key = item.Priority;
      }

      bFilter = false;
      if (selectedTopItems.length === 0) {
        bFilter = true;
      } else {
        selectedTopItems.forEach((selected) => {
          if (selected.key === key) bFilter = true;
          else if (selected.key === 'Total') bFilter = true;
        });
      }

      if (bFilter === true) {
        let importance = '';
        if (item.Priority.indexOf('Low') > -1) importance = 'Low';
        if (item.Priority.indexOf('High') > -1) importance = 'High';
        if (item.Priority.indexOf('Medium') > -1) importance = 'Medium';
        if (item.Priority.indexOf('Critical') > -1) importance = 'Critical';

        if (selectedMonths.indexOf(month) > -1) {
          if (_dictData[key] === undefined) {
            _dictData[key] = {};
            _dictData[key]['key'] = key;
            _dictData[key]['month'] = month;
            _dictData[key]['value'] = {};
          }

          if (_dictData[key]['value'][item.Name] === undefined) {
            _dictData[key]['value'][item.Name] = {};
            _dictData[key]['value'][item.Name]['Name'] = item.Name;
            _dictData[key]['value'][item.Name]['Importance'] = importance;
            _dictData[key]['value'][item.Name]['Result'] = item.Result
              ? parseFloat(item.Result)
              : 0;
            _dictData[key]['value'][item.Name]['Target'] = item.Target
              ? parseFloat(item.Target)
              : 0;
            _dictData[key]['value'][item.Name]['Enable'] = item.Enable;
            _dictData[key]['value'][item.Name]['DisplayFormat'] =
              item.DisplayFormat;
            _dictData[key]['value'][item.Name]['DesiredOutcome'] =
              item.DesiredOutcome;
            _dictData[key]['value'][item.Name]['Outcome'] =
              Outcome === 'Achieved' ? 1 : Outcome === 'Not Achieved' ? -1 : 0;
            _dictData[key]['value'][item.Name]['Direction'] =
              dictData[key] === undefined ||
              dictData[key]['value'] === undefined ||
              dictData[key]['value'][item.Name] === undefined
                ? 0
                : dictData[key]['value'][item.Name].Result >
                    parseFloat(item.Result)
                  ? -1
                  : parseFloat(item.Result) === 0
                    ? 2
                    : 1;
            if (savedLeftItems.length === 0) {
              setSavedLeftItems([item.Name]);
            }
          }
        }

        if (dictData[key] === undefined) {
          dictData[key] = {};
          dictData[key]['key'] = key;
          dictData[key]['month'] = month;
          dictData[key]['value'] = {};
        }

        if (dictData[key]['value'][item.Name] === undefined) {
          dictData[key]['value'][item.Name] = {};
        }

        dictData[key]['value'][item.Name]['Name'] = item.Name;
        dictData[key]['value'][item.Name]['Importance'] = importance;
        dictData[key]['value'][item.Name]['Result'] = item.Result
          ? parseFloat(item.Result)
          : 0;
        dictData[key]['value'][item.Name]['Target'] = item.Target
          ? parseFloat(item.Target)
          : 0;
        dictData[key]['value'][item.Name]['Enable'] = item.Enable;
        dictData[key]['value'][item.Name]['DisplayFormat'] = item.DisplayFormat;
        dictData[key]['value'][item.Name]['DesiredOutcome'] =
          item.DesiredOutcome;
        dictData[key]['value'][item.Name]['Outcome'] =
          Outcome === 'Achieved' ? 1 : Outcome === 'Not Achieved' ? -1 : 0;
      }
    });

    Object.keys(_dictData).map((key) => newData.push(_dictData[key]));

    newData.sort((a, b) => {
      if (a.key.toLowerCase() > b.key.toLowerCase()) return -1;
      if (a.key.toLowerCase() < b.key.toLowerCase()) return 1;
      return 0;
    });

    // getting right linechart data
    summaryData.forEach((item) => {
      let month = getMonth(item.Date);
      if (savedLeftItems.indexOf(item.Name) > -1) {
        if (_linedata[month] === undefined) {
          _linedata[month] = {};
          _linedata[month]['month'] = month;
          _linedata[month]['Result'] = Number(
            parseFloat(item.Result).toFixed(2),
          );
          _linedata[month]['Target'] = Number(
            parseFloat(item.Target).toFixed(2),
          );
          _linedata[month]['DesiredOutCome'] = item.DesiredOutcome;
        } else {
          _linedata[month]['Result'] += parseFloat(item.Result);
          _linedata[month]['Target'] += parseFloat(item.Target);
          _linedata[month]['Result'] = Number(
            parseFloat(_linedata[month]['Result']).toFixed(2),
          );
          _linedata[month]['Target'] = Number(
            parseFloat(_linedata[month]['Target']).toFixed(2),
          );
          _linedata[month]['DesiredOutCome'] = item.DesiredOutcome;
        }
      }
    });

    let fiscalMonths = getMonths(defaultStartMonth);

    fiscalMonths.forEach((month) => {
      if (_linedata[month] !== undefined) newLinedata.push(_linedata[month]);
    });
    
    setData(newData);
    setLinedata(newLinedata);
  }, [summaryData, selectedTopItems, selectedRightItems, choice, savedLeftItems, defaultStartMonth]);

  useEffect(() => {
    _prepareData();
  }, [summaryData, selectedTopItems, selectedLeftItems, selectedRightItems, choice, _prepareData]);

  useEffect(() => {
    setSelectedLines([]);
  }, [selectedLeftItems]);

  const _showTooltip = useCallback((event, xScale, yScale, isBar = true) => {
    if (tooltipTimeout) clearTimeout(tooltipTimeout);

    let tooltipData = {},
      top,
      left,
      pTop,
      pLeft;

    let tmpX = [];
    if (linedata.length === 0) return;

    const { x } = localPoint(event);

    linedata.forEach((item) => {
      tmpX.push({
        month: item.month,
        value: item,
        xPos: xScale(item.month) + 50,
      });
    });

    let _x = x - xScale.step() / 2;
    tmpX.sort((a, b) => Math.abs(_x - a.xPos) - Math.abs(_x - b.xPos));
    pLeft = (tmpX ? tmpX[0].xPos : 0) + xScale.step() / 2;
    pTop = tmpX ? yScale(tmpX[0].value.Result) : 0;

    top = event.clientY - 80;
    left = event.clientX;
    tooltipData = tmpX[0];

    tooltipData['pLeft'] = pLeft;
    tooltipData['pTop'] = pTop;
    tooltipData['isBar'] = isBar;

    showTooltip({
      tooltipData,
      tooltipTop: top,
      tooltipLeft: left,
    });
  }, [linedata, showTooltip]);

  const _hideTooltip = useCallback(() => {
    tooltipTimeout = setTimeout(() => {
      hideTooltip();
    }, 300);
  }, [hideTooltip]);

  const _getColor = useCallback((item, key, type = 'chart') => {
    let activeColor = 'black';
    let disableColor = 'grey';
    if (type === 'arrow') {
      if (item.DesiredOutcome === 'Greater') {
        if (item.Direction === 1) {
          activeColor = '#8dc63f';
          disableColor = '#e0ebd2';
        } else {
          activeColor = '#868686';
          disableColor = '#dfdfdf';
        }
      } else {
        if (item.Direction === 1) {
          activeColor = '#868686';
          disableColor = '#dfdfdf';
        } else {
          activeColor = '#8dc63f';
          disableColor = '#e0ebd2';
        }
      }
    } else {
      if (item.Outcome === 1) {
        activeColor = '#8dc63f';
        disableColor = '#e0ebd2';
      } else if (item.Outcome === -1) {
        activeColor = '#868686';
        disableColor = '#dfdfdf';
      } else {
        activeColor = '#e9f323';
        disableColor = '#f1f3cd';
      }
    }

    if (selectedLeftItems.length === 0) {
      return activeColor;
    }

    for (let i = 0; i < selectedLeftItems.length; i++) {
      if (
        selectedLeftItems[i].Name === item.Name &&
        selectedLeftItems[i].key === key
      ) {
        return activeColor;
      }
    }

    return disableColor;
  }, [selectedLeftItems]);

  const _handleChart = useCallback((event, value, key) => {
    let _selectedLeftItems,
      _selectedBars,
      _savedLeftItems = [];

    if (event.shiftKey) {
      _selectedBars = selectedBars.slice();
      _selectedLeftItems = selectedLeftItems.slice();

      let index = NaN;
      for (let i = 0; i < selectedBars.length; i++) {
        if (selectedBars[i] === event.target) {
          index = i;
          break;
        }
      }

      if (isNaN(index)) {
        event.target.classList.add('barActive');
        _selectedBars.push(event.target);
        if (value === null) {
          data.forEach((d) => {
            if (d.key === key) {
              Object.keys(d.value).forEach((subd) => {
                _selectedLeftItems.push({ key: key, Name: d.value[subd].Name });
                if (_savedLeftItems.length === 0)
                  _savedLeftItems = [d.value[subd].Name];
              });
            }
          });
        } else {
          _selectedLeftItems.push({ key: key, Name: value.Name });
        }
      } else {
        event.target.classList.remove('barActive');
        _selectedBars.splice(index, 1);
        _selectedLeftItems.splice(index, 1);
      }
    } else {
      let exist = false;
      selectedBars.forEach((selectedBar) => {
        selectedBar.classList.remove('barActive');
        if (selectedBar.className === event.target.className) exist = true;
      });

      if (exist && selectedBars.length === 1) {
        _selectedLeftItems = [];
        _selectedBars = [];
      } else {
        _selectedLeftItems = [];
        if (value === null) {
          data.forEach((d) => {
            if (d.key === key) {
              Object.keys(d.value).forEach((subd) => {
                _selectedLeftItems.push({ key: key, Name: d.value[subd].Name });
              });
            }
          });
        } else {
          _selectedLeftItems = [
            {
              key: key,
              Name: value.Name,
              DesiredOutcome: value.DesiredOutcome,
            },
          ];
        }
        _selectedBars = [event.target];
        event.target.classList.add('barActive');
      }
    }

    _selectedLeftItems.forEach((d) => {
      _savedLeftItems.push(d.Name);
    });

    setSelectedBars(_selectedBars);
    setSavedLeftItems(_savedLeftItems);

    updateFilter({
      selectedLeftItems: _selectedLeftItems,
    });
  }, [selectedBars, selectedLeftItems, data, updateFilter]);

  const _handleLineSelect = useCallback((event, xScale, yScale) => {
    let newSelectedRightItems = selectedRightItems.slice();
    let newSelectedLines = selectedLines.slice();

    if (linedata.length === 0) return;

    const { x } = localPoint(event);

    let selected = [];
    linedata.forEach((item) => {
      selected.push({
        month: item.month,
        value: item,
        xPos: xScale(item.month) + 50,
      });
    });

    let _x = x - xScale.step() / 2;
    selected.sort((a, b) => Math.abs(_x - a.xPos) - Math.abs(_x - b.xPos));

    let left = (selected ? selected[0].xPos : 0) + xScale.step() / 2;
    let top = selected ? yScale(selected[0].value.Result) : 0;

    if (event.shiftKey) {
      let index = NaN;
      for (let i = 0; i < selectedRightItems.length; i++) {
        if (selectedRightItems[i] === selected[0].month) {
          index = i;
          break;
        }
      }

      if (isNaN(index)) {
        newSelectedRightItems.push(selected[0].month);
        newSelectedLines.push({ month: selected[0].month, left: left, top: top });
      } else {
        newSelectedRightItems.splice(index, 1);
        newSelectedLines.splice(index, 1);
      }
    } else {
      newSelectedRightItems = [];
      newSelectedLines = [];
      newSelectedRightItems.push(selected[0].month);
      newSelectedLines.push({ month: selected[0].month, left: left, top: top });
    }

    setSelectedLines(newSelectedLines);

    updateFilter({
      selectedRightItems: newSelectedRightItems,
    });
  }, [linedata, selectedRightItems, selectedLines, updateFilter]);

  const handleLabel = useCallback((event, label, labelIndex) => {
    if (event.shiftKey) {
      if (selectedRightLabels.indexOf(label) > -1) {
        updateFilter({
          selectedRightLabels: selectedRightLabels.filter((item) => item !== label),
          selectedRightItems: selectedRightItems.filter((item) => item !== labelIndex),
        });
      } else {
        updateFilter({
          selectedRightLabels: [...selectedRightLabels, label],
          selectedRightItems: [...selectedRightItems, labelIndex],
        });
      }
    } else {
      if (selectedRightLabels.indexOf(label) > -1) {
        updateFilter({
          selectedRightLabels: selectedRightLabels.filter((item) => item !== label),
          selectedRightItems: selectedRightItems.filter((item) => item !== labelIndex),
        });
      } else {
        updateFilter({
          selectedRightLabels: [label],
          selectedRightItems: [labelIndex],
        });
      }
    }
  }, [selectedRightLabels, selectedRightItems, updateFilter]);

  const width = window.innerWidth;
  const height = window.innerHeight / 2 - 60;
  const margin = {
    top: 10,
    right: 10,
    bottom: 10,
    left: 10,
  };

  const { pageYOffset, xMax, yMax } = getParams(
    window,
    width,
    height,
    margin,
  );

  let groupLengths = [],
    maxGroupLength = 0,
    nameLengths = [],
    maxNameLength = 0;
  summaryData.forEach((d) => {
    groupLengths.push(d.Group.length);
    nameLengths.push(d.Name.length);
  });
  if (groupLengths.length > 0) {
    maxGroupLength = Math.max(...groupLengths);
    maxNameLength = Math.max(...nameLengths);
  }

  let rightWidth =
    xMax - maxGroupLength * 6.5 - maxNameLength * 6.8 - 470 > 50
      ? xMax - maxGroupLength * 6.5 - maxNameLength * 6.8 - 470
      : 50;

  let lineMin = 0,
    lineMax = 0,
    lineTarget;

  let fiscalMonths = getMonths2(
    defaultMonth,
    defaultStartMonth,
  );

  let xScale = scaleBand()
    .domain(getMonths(defaultStartMonth))
    .rangeRound([0, rightWidth - 50])
    .padding(0.2);

  linedata.forEach((d) => {
    lineMin = Math.min(lineMin, d.Result);
    lineMax = Math.max(lineMax, d.Result);
    lineTarget = d.Target;
  });

  let validMonths = [];
  linedata.forEach((d, k) => {
    if (d.value !== 0 && fiscalMonths.indexOf(d.month) > -1)
      validMonths[k] = d;
  });
  let pdfExport =
    window.innerWidth < 1280 && window.innerWidth > 1270 ? true : false;

  let yScale = scaleLinear({
    domain: [lineMin * 1.2, lineMax * 1.2],
    range: [pdfExport ? yMax - 50 : yMax, 10],
    nice: true,
  });

  let xSelector = (d) => d.month;
  let ySelector = (d) => d.Result;

  let botttomHeight = 0;
  data.map((d) => (botttomHeight += Object.keys(d.value).length));
  botttomHeight = 21 * botttomHeight + 60;
  let realIndex = 0;

  let trendLabels = '';
  selectedLeftItems.forEach((d) => {
    trendLabels = trendLabels + ' ' + d.Name;
  });

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ height: botttomHeight }}>
        <div
          className="flex"
          align="left"
          style={{
            border: 'solid 1px #cdcdcd',
            width: maxGroupLength * 6.5 + maxNameLength * 6.8 + 452,
          }}
        >
          <div>
            <p style={{ ...formatedStyle(maxGroupLength * 6.5, 12, 0, 1), padding: '4px 0' }}>Group</p>
          </div>
          <div>
            <p style={{ ...formatedStyle(maxNameLength * 6.8, 12, 0, 1), padding: '4px 0' }}>Name</p>
          </div>
          <div>
            <p style={{ ...formatedStyle(100, 12, 0, 1), padding: '4px 0' }}>Importance</p>
          </div>
          <div>
            <p style={{ ...formatedStyle(100, 12, 0, 1), padding: '4px 0' }}>Result</p>
          </div>
          <div>
            <p style={{ ...formatedStyle(100, 12, 0, 1), padding: '4px 0' }}>Target</p>
          </div>
        </div>
        
        {data.map((item, index) => {
          let subItems = [];
          let renderItems = [];

          Object.keys(item.value).forEach((subitem) => {
            subItems.push(item.value[subitem]);
          });

          subItems.forEach((value, inx) => {
            let value_result, value_target;
            if (value.DisplayFormat === 'Percent') {
              value_result = `${(Math.round(value.Result * 10) / 10).toFixed(
                1,
              )}%`;
              value_target = `${(Math.round(value.Target * 10) / 10).toFixed(
                1,
              )}%`;
            } else if (value.DisplayFormat === 'Price') {
              value_result = thousandFormat2(value.Result);
              value_target = thousandFormat2(value.Target);
            } else if (value.DisplayFormat === 'Day') {
              value_result = `${parseInt(value.Result)} Days`;
              value_target = `${parseInt(value.Target)} Days`;
            } else {
              value_result = value.Result.toFixed(2);
              value_target = value.Target.toFixed(2);
            }
            realIndex++;
            
            renderItems.push(
              <div
                className="flex"
                align="left"
                key={`subcateory-${inx}`}
                onClick={(event) => _handleChart(event, value, item.key)}
              >
                <div
                  className={
                    realIndex % 2 === 0
                      ? ''
                      : 'tableColor4 grayHover'
                  }
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <div className="flex" align="left">
                    <p
                      className={`subcateory-${inx}`}
                      style={formatedStyle(
                        maxNameLength * 6.8,
                        12,
                        0,
                        0,
                        'pointer',
                      )}
                    >
                      {value.Name}
                    </p>
                    <p
                      className={`subcateory-${inx}`}
                      style={formatedStyle(100, 12, 0, 0, 'pointer')}
                    >
                      {value.Importance}
                    </p>
                    <p
                      className={`subcateory-${inx}`}
                      style={formatedStyle(100, 12, 0, 0, 'pointer')}
                    >
                      {value_result}
                    </p>
                    <p
                      className={`subcateory-${inx}`}
                      style={formatedStyle(100, 12, 0, 0, 'pointer')}
                    >
                      {value_target}
                    </p>
                  </div>
                </div>

                <div
                  className={
                    realIndex % 2 === 0
                      ? ''
                      : 'tableColor4 grayHover'
                  }
                  style={formatedStyle(150, 13, 0, 0, 'pointer')}
                  align="center"
                >
                  <div
                    className={`subcateory-${inx}`}
                    style={{
                      margin: '1.5px 0',
                      width: '100%',
                      height: 18,
                      backgroundColor: _getColor(value, item.key),
                    }}
                  ></div>
                </div>
              </div>,
            );
          });
          return (
            <div
              id="kpi_bottom"
              key={`cateory-${index}`}
              className="flex"
              align="left"
              style={{
                borderLeft: 'solid 1px #cdcdcd',
                borderBottom: 'solid 1px #cdcdcd',
                width: maxGroupLength * 6.5 + maxNameLength * 6.8 + 452,
              }}
            >
              <div style={{ paddingTop: 4 }}>
                <p
                  className={`grayHover`}
                  style={formatedStyle(
                    maxGroupLength * 6.5,
                    12,
                    0,
                    0,
                    'pointer',
                  )}
                  onClick={(event) =>
                    _handleChart(event, null, item.key)
                  }
                >
                  &nbsp;{item.key}
                </p>
              </div>
              <div style={{ borderRight: 'solid 1px #cdcdcd' }}>
                {renderItems}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ marginLeft: 20 }}>
        <div style={{ marginLeft: 12 }} className="subtitle">
          <Truncate
            width={rightWidth}
            ellipsis={<span>... {savedLeftItems.length} items</span>}
          >
            Trend - {trendLabels === '' ? savedLeftItems : trendLabels}
          </Truncate>
        </div>

        <svg width={rightWidth} height={yMax + 15}>
          <defs>
            <clipPath id="positive">
              <rect
                x={0}
                y={0}
                width={width}
                height={yScale(lineTarget) > 0 ? yScale(lineTarget) : 0}
              />
            </clipPath>
            <clipPath id="negative">
              <rect
                x={0}
                y={yScale(lineTarget) > 0 ? yScale(lineTarget) : 0}
                width={width}
                height={height}
              />
            </clipPath>
          </defs>
          <Group>
            <LinePath
              data={validMonths}
              x={(d) =>
                xScale(xSelector(d))
                  ? xScale(xSelector(d)) + xScale.step() / 2 + 50
                  : 0
              }
              y={(d) => (yScale(ySelector(d)) ? yScale(ySelector(d)) : 0)}
              strokeWidth={8}
              stroke="#8dc63f"
              strokeLinecap="round"
              fill="transparent"
              clipPath={
                selectedLeftItems.length === 1
                  ? selectedLeftItems[0].DesiredOutcome === 'Greater'
                    ? 'url(#positive)'
                    : 'url(#negative)'
                  : validMonths.length > 0 &&
                      validMonths[0].DesiredOutCome === 'Greater'
                    ? 'url(#positive)'
                    : 'url(#negative)'
              }
            />
            <LinePath
              data={validMonths}
              x={(d) =>
                xScale(xSelector(d))
                  ? xScale(xSelector(d)) + xScale.step() / 2 + 50
                  : 0
              }
              y={(d) => (yScale(ySelector(d)) ? yScale(ySelector(d)) : 0)}
              strokeWidth={8}
              stroke="#868686"
              strokeLinecap="round"
              fill="transparent"
              clipPath={
                selectedLeftItems.length === 1
                  ? selectedLeftItems[0].DesiredOutcome === 'Greater'
                    ? 'url(#negative)'
                    : 'url(#positive)'
                  : validMonths.length > 0 &&
                      validMonths[0].DesiredOutCome === 'Greater'
                    ? 'url(#negative)'
                    : 'url(#positive)'
              }
            />
            <Bar
              x={50}
              y={10}
              width={rightWidth}
              height={yMax + 10}
              fill="transparent"
              onMouseMove={(event) => {
                if (tooltipTimeout) clearTimeout(tooltipTimeout);
                _showTooltip(event, xScale, yScale);
              }}
              onMouseLeave={(event) => {
                tooltipTimeout = setTimeout(() => {
                  _hideTooltip();
                }, 300);
              }}
              onTouchMove={(event) => {
                if (tooltipTimeout) clearTimeout(tooltipTimeout);
                _showTooltip(event, xScale, yScale);
              }}
              onTouchEnd={(event) => {
                tooltipTimeout = setTimeout(() => {
                  _hideTooltip();
                }, 300);
              }}
              onClick={(event) => {
                _handleLineSelect(event, xScale, yScale);
              }}
            />

            {tooltipOpen && (
              <g>
                <circle
                  cx={tooltipData.pLeft}
                  cy={tooltipData.pTop}
                  r={8}
                  fill={positiveActiveColor}
                  stroke="black"
                  strokeWidth={2}
                  style={{ pointerEvents: 'none' }}
                />
              </g>
            )}

            {selectedLines.map((d, i) => {
              let radius = 0;
              let strokeWidth = 0;
              radius = 8;
              strokeWidth = 3;

              return (
                <g key={`circle-${i}`}>
                  <circle
                    cx={d.left}
                    cy={d.top}
                    r={radius}
                    fill={positiveActiveColor}
                    stroke="black"
                    strokeWidth={strokeWidth}
                    style={{ pointerEvents: 'none' }}
                  />
                </g>
              );
            })}
            <text
              x={52}
              y={isNaN(yScale(lineTarget)) ? 0 : yScale(lineTarget) - 10}
              fill="black"
              fontSize={11}
            >
              Target
            </text>

            <LinePath
              data={[
                {
                  x: 50,
                  y: yScale(lineTarget) ? yScale(lineTarget) : 0,
                },
                {
                  x: rightWidth,
                  y: yScale(lineTarget) ? yScale(lineTarget) : 0,
                },
              ]}
              x={(d) => (d.x ? d.x : 0)}
              y={(d) => (d.y ? d.y : 0)}
              stroke="#555555"
              strokeDasharray="5,5"
            />

            <AxisLeft
              left={50}
              hideTicks={false}
              scale={yScale}
              stroke="black"
              tickStroke="black"
              numTicks={5}
              tickLabelProps={(value, index) => ({
                fill: 'black',
                fontSize: 11,
                textAnchor: 'end',
                dy: '0.33em',
              })}
              tickComponent={({ formattedValue, ...tickProps }) => (
                <text {...tickProps} fill="black">
                  {Number(formattedValue.toString().replace(/,/g, '')) > 1000
                    ? Math.round(
                        Number(formattedValue.toString().replace(/,/g, '')) /
                          1000,
                      ) + 'K'
                    : formattedValue}
                </text>
              )}
            />

            <AxisBottom
              hideTicks={true}
              width={rightWidth}
              numTicks={12}
              scale={xScale}
              top={pdfExport ? yMax - 50 : yMax}
              left={50}
              stroke="black"
              tickStroke="black"
              tickLabelProps={(value, index) => ({
                fontSize: 11,
                textAnchor: 'middle',
                dy: '-0.5em',
              })}
              tickComponent={({ formattedValue, ...tickProps }) => (
                <text
                  {...tickProps}
                  style={{
                    fontWeight:
                      selectedRightLabels.indexOf(enMonths[formattedValue]) > -1 ? 700 : 500,
                  }}
                  fill={
                    selectedRightLabels.indexOf(enMonths[formattedValue]) > -1
                      ? activeLabelColor
                      : 'black'
                  }
                  onClick={(event) =>
                    handleLabel(event, enMonths[formattedValue], Number(formattedValue))
                  }  
                >
                  {enMonths[formattedValue]}
                </text>
              )}
            />
          </Group>
        </svg>
      </div>
      
      {tooltipOpen && (
        <TooltipWithBounds
         
          top={tooltipTop + pageYOffset}
          left={tooltipLeft}
        >
          {tooltipData.isBar ? (
            <div className="bkg-white color-black">
              <div className="pdv-10">
                Month of Period as Date{' '}
                <strong>{enMonths[tooltipData.month]}</strong>
              </div>
              <div className="ft-12">
                Result{' '}
                <strong>{thousandFormat(tooltipData.value.Result)}</strong>
              </div>
              <div className="ft-12">
                Target{' '}
                <strong>{thousandFormat(tooltipData.value.Target)}</strong>
              </div>
            </div>
          ) : null}
        </TooltipWithBounds>
      )}
    </div>
  );
};

BottomChart.propTypes = {
  summaryData: PropTypes.array.isRequired,
  defaultMonth: PropTypes.number.isRequired,
  defaultStartMonth: PropTypes.number.isRequired,
  updateFilter: PropTypes.func.isRequired,
  selectedTopItems: PropTypes.array.isRequired,
  selectedLeftItems: PropTypes.array.isRequired,
  selectedRightItems: PropTypes.array.isRequired,
  choice: PropTypes.string.isRequired,
};

export default BottomChart;
